import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTahun } from "@/hooks/useTahun";
import { BarChart3, LayoutList } from "lucide-react"; // Pastikan install lucide-react
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { BarChartComponent } from "./partial/BarChart";
import TabelRekap from "./partial/TabelRekap";

export default function DashboardOperatorPascaPage() {
  const [searchParams, setSearchParams] = useSearchParams();

  // Ambil state dari URL atau default ke GRAFIK
  const initialMenu = searchParams.get("menu") === "DATA" ? "DATA" : "GRAFIK";
  const [activeMenu, setActiveMenu] = useState<"GRAFIK" | "DATA">(initialMenu);

  const { selectedTahun } = useTahun();

  // Handler ganti Tab + Sync URL
  const handleTabChange = (value: string) => {
    const menu = value as "GRAFIK" | "DATA";
    setActiveMenu(menu);

    const newParams = new URLSearchParams(searchParams);
    newParams.set("menu", menu);
    setSearchParams(newParams);
  };

  return (
    <div className="space-y-6 min-h-screen pb-10">
      {/* --- HEADER SECTION --- */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold tracking-tight text-slate-900 dark:text-white">
            Dashboard Pascasarjana
          </h1>
          <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
            Ringkasan data pendaftaran dan grafik statistik penerimaan.
          </p>
        </div>
        <div className="flex items-center gap-2 px-4 py-2 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-lg shadow-sm">
          <span className="text-sm font-medium text-slate-500 dark:text-slate-400">
            Tahun Akademik:
          </span>
          <span className="text-sm font-bold text-slate-900 dark:text-white">
            {selectedTahun?.label}
          </span>
        </div>
      </div>

      {/* --- MAIN TABS --- */}
      <Tabs
        defaultValue={activeMenu}
        onValueChange={handleTabChange}
        className="space-y-6"
      >
        <TabsList className="grid w-full grid-cols-2 lg:w-[400px] bg-slate-100 dark:bg-slate-900 p-1">
          <TabsTrigger
            value="GRAFIK"
            className="data-[state=active]:bg-white dark:data-[state=active]:bg-slate-800 data-[state=active]:shadow-sm transition-all"
          >
            <BarChart3 className="w-4 h-4 mr-2" />
            Visualisasi Grafik
          </TabsTrigger>
          <TabsTrigger
            value="DATA"
            className="data-[state=active]:bg-white dark:data-[state=active]:bg-slate-800 data-[state=active]:shadow-sm transition-all"
          >
            <LayoutList className="w-4 h-4 mr-2" />
            Data Tabel
          </TabsTrigger>
        </TabsList>

        {/* CONTENT: GRAFIK */}
        <TabsContent
          value="GRAFIK"
          className="space-y-4 animate-in fade-in-50 duration-300"
        >
          <Card className="border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-sm">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <BarChart3 className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                Statistik Pendaftaran
              </CardTitle>
              <CardDescription>
                Grafik perbandingan pendaftar berdasarkan jalur masuk tahun{" "}
                {selectedTahun?.label}.
              </CardDescription>
            </CardHeader>
            <CardContent className="pl-2">
              <BarChartComponent tahun={selectedTahun?.label} />
            </CardContent>
          </Card>
        </TabsContent>

        {/* CONTENT: DATA */}
        <TabsContent
          value="DATA"
          className="space-y-6 animate-in fade-in-50 duration-300"
        >
          <div className="min-h-[500px]">
            <TabelRekap />
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
